import type { Point } from "./geometry";

const APPROACH_SECONDS = 0.4;
const STOP_DISTANCE = 2;

/** Manual following slows near the cursor without starting a pathfinding job. */
export function mouseFollowMovement(position: Point, target: Point, maxSpeed: number | null): Point {
  const dx = target.x - position.x, dy = target.y - position.y;
  const distance = Math.hypot(dx, dy);
  if (maxSpeed === null || !Number.isFinite(maxSpeed) || maxSpeed <= 0 ||
      !Number.isFinite(distance) || distance <= STOP_DISTANCE) return { x: 0, y: 0 };
  const scale = Math.min(1, distance / (maxSpeed * APPROACH_SECONDS));
  return { x: dx / distance * scale, y: dy / distance * scale };
}
